import myaxios from "../../components/Axios";

export const createTagService = (entity, id, tags) => myaxios.post(`/ajax/${entity}/${id}/mark?labels=${tags}`)